#import "@core/schema/fragments/CustomerFull.graphql"

query (
  $input: CustomerSignInWithGoogleInput!
) {
  signInWithGoogle(
    input: $input
  ) {
    customer {
      ...CustomerFull
    }
    b2bPricingLevelSecretKey
  }
}
